import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'mp_stable_id';

/** Returns a browser-persistent identifier for anonymous Statsig bucketing. */
export function getStableId(): string | undefined {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) {
      return existing;
    }

    const generated = uuid();
    window.localStorage.setItem(STORAGE_KEY, generated);
    return generated;
  } catch {
    return undefined;
  }
}
